import { render, staticRenderFns } from "./FixedEventsMobile.vue?vue&type=template&id=b2b6e586&scoped=true"
import script from "./FixedEventsMobile.vue?vue&type=script&lang=js"
export * from "./FixedEventsMobile.vue?vue&type=script&lang=js"
import style0 from "./FixedEventsMobile.vue?vue&type=style&index=0&id=b2b6e586&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b6e586",
  null
  
)

export default component.exports